import { render } from "./PieComponent.vue?vue&type=template&id=70febe8a"
import script from "./PieComponent.vue?vue&type=script&lang=js"
export * from "./PieComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__